
/**
 * Configuration settings for the application.
 * This module centralizes all the hardcoded variables and settings.
 */
const config = {
    // Error Messages
    errorMessageForName: "من فضلك أدخل الأسم",
    errorMessageForsmallName: "الأسم صغير جدا",
    errorMessageForDesign: "من فضلك أختر تصميم",
    errorMessageForWhiteSpaces: "من فضلك أدخل الأسم بشكل صحيح",
    errorMessageForSelectDesign: "من فضلك أختر تصميم",

    // Facebook App ID
    facebookAppId: "286287053106964",
    // Cookie Names
    cookieblockname: "_bk",
    cookieblockip: "block-ip",

    // Download Limits
    totaldowloadKey: '_tdownload',
    maxTotalDownloadPerCountry: 120,
    maxDesktopDownload: 35,
    maxCurrentDesignDownload: 1,
    sharedTodayKey: '_sharedToday',
    fbSharedExpiredHours: 12,
    WaitTimeAfterUserShareInMinutes: 10,
    // API and Keys
    apiBase: 'https://pronileserver11-001-site1.anytempurl.com/api/notifications',
    publicKey: 'BFOoyf3_FA9sumkAHCvycWgerGrjKBiIPkFISXNBnRcrmlpa6fxXURPgPPZRqr7wSJeU6GnOIKa6bTpkaMSvzb8',
    TokenKey: "token",
    formDataKey: "formData", // save data by session state
    deferredPrompt: null,
    installAppKey: 'install',
    installAppTitle: "ثبت تطبيق صمّم بنفسك",
    subscribeKey: "subscribe",
    subscribeTitle: "تفعيل التنبيهات",

    // History and Usage
    maxHistoryItems: 25, // history items for localStorage
    historyKey: 'imagesHistory',
    usagenKey: 'usagen',
    images: [], // images of images History , 
    badImages: [],
    currentIndexToDelete: 0, // belong to image history in mydesigns page

    // Share and Navigation
    noParticipantKey: 'non-participant',
    noShareStatus: 'non-share',
    lastChance: 'last-chance',
    fbAppShareOn: false,
    navigateExternalKey: 'no-external',
    MessageCountCookie: '_msgcount',
    isForceShare: false,
    ShowModal: false,
    BodyModal: "",
    TitleModal: "",
    Shares: 'shares', // shares is the key of share count
    isSharedLink: false, // this option determine if we use it or not
    currentSharedLink: "", // the current shared link from internal website
    isUserShareLinkToday: false, // check if the user share link of our website today
    // Designs and Countries not following sharing rules
    designsNotFollowRules: ['moled-ph', 'moled-ph2', 'moled-phs', 'bth-ph', 'adha-ph', 'eidf-ph2', 'certs-phqsw', 'certs-nphqsw', 'certs-phw', 'certs-phw2', 'rm-elv', 'rm-ph', 'adha-nph', 'adha-pray', 'adha-od', 'adha-kids', 'adha', 'adha-bu', 'bth-nph', 'certs-sph', 'eidf-nph', 'certs-nphqs', 'certs-nphw', 'rm-pray2', 'certs-nsph', 'nr-wc', 'newyear-vd', 'sy-newyear', 'newyear-prayer', 'newyear', 'nr-ph', 'newyear-rm', 'wf-certs', 'hs-certs', 'duaa-2025', 'certs-nphqw', 'certs-phqw', 'school-kids', 'bistory-ph', 'certs-su', 'certs-nph', 'school-nkids', 'lbl-ph', 'lbl-nph', 'couples-anv', 'v-couples-anv', 'v-weeding-inv'],
    countriesNotFollowRules: ['KW', 'EG', 'YE', 'QA', 'BH', 'US', 'DZ', 'JO', 'CA', 'FR', 'OM', 'DE', 'SA', 'NL', 'AE', 'IL', 'MA', 'LY', 'AU', 'RO', 'TN', 'GB', 'PS', 'TR', 'IT', 'IE'],

    // Feature Flags for system behavior
    isUserNotApplicable: false, // for users of chrome
    testMode: false, // TEST ENVIRONMENT
    //useMyServer: true,
    changeBalancerMode: false, // stop using balancer
    isUsePhpForDownload: false,
    isDownloadPageValid: true,
    isCookeValuesEqual: false,
    isCrawlers: false,
    controls: ["t1", "t2", "t3", "t4"], // controls count of input texts max is 4  
    // Other settings for setting and fb
    cookieHours: 8,
    hostsCount: 5,
    // update ac on 18-10-2026
    ac: "EAAjnXLaOGZAEBSzG5RLLMBGZAVr2bOZCZAIfsJAvWJUDfzLdwgXB504mhw65xQe7cZC6gYdZABJgZC8lqMGLvMHR50NAoN1946BvPrxSUaK0ZAJVyvwgC8vJtPysoWZBcxZC6vDFJZAd0FnIHDrSsgqd6CS7vzeC6ZABCZBRUNaJTm6v9KplZBC5dvVsgGyi1biZC0HmC7vVeuXZBY4qcfx3luqZBI4zN",

    // messages
    pageName: "صمم بنفسك تصميم بأسمك",
    pageId: "Design.a.card.with.your.name",
    profileId: "1067063833383222",
    appId: "286287053106964",
    usermessage: "شارك بالمنشور الرئيسي على صفحتك في الفيس بوك حتى تستطيع عمل أكثر من تصميم",
    //userModalMessage: "كل عام وأنتم بخير! 📅✨ \nاحصل على المزيد من التصميمات المجانية بمجرد مشاركة منشورنا على صفحتك! مشاركتك تساعد في نشر الموقع ليستفيد المزيد من المستخدمين، كما تمنحك وصولًا أكبر إلى تصاميم مميزة مجانًا.\nقم بالمشاركة الآن، وبعدها سيتم توجيهك تلقائيًا إلى هنا لتحميل تصميمك.\nشكرًا لك على دعمك المستمر! ❤️",
    // userModalMessage: "🌙✨ كل عام وأنتم بخير ✨🌙\nفضلاً وليس أمرًا، يرجى مشاركة الموقع على فيسبوك وليس التصميم الحالي، مشاركتك تساهم في انتشار الموقع ليستفيد منه أكبر عدد من المستخدمين.\nبعد الضغط على «شارك الآن» وتنفيذ المشاركة، اضغط على «تمت المشاركة» لتختفي الرسالة ويمكنك تحميل التصميم وعمل المزيد من التصميمات مجانًا.",
    userModalMessage: "🌙✨ كل عام وأنتم بخير ✨🌙\nلو عجبك التصميم، ساعدنا بمشاركة البوست الموجود على صفحة «صمّم بنفسك» على فيسبوك من خلال الضغط على «شارك الآن» \n💚 المشاركة ستكون للبوست وليس لتصميمك الحالي؛ فالموقع مجاني ومشاركتك هي الدعم الوحيد لاستمراره وتساعدنا على تقديم المزيد من التصميمات المجانية.\nبعد المشاركة اضغط «تمت المشاركة» لتحميل التصميم والاستمرار في استخدام الموقع مجانًا.",
    // designName : utils.getDesignName(),

    designName: "",
    designType: "",
    pageType: "",
    domain: window.location.origin,
    ref: document.referrer,
    category: "",
    categoriesUrl: [
        { name: "certs", url: "/certs" },
        { name: "newyear", url: "/newyear2023" },
        { name: "kids", url: "/kids" },
        { name: "romantic", url: "/romantic" },
        { name: "occasions", url: "/occasions" },
        { name: "ramadan", url: "/ramadan" },
        { name: "adha", url: "/eid" },
    ],
    sharedLinkDetails: [
        { name: "moled", path: "m", message: "أرسلت إليك رسالة تهنئة وتصميم خاص بمناسبة المولد النبوي\nتم إنشاء التصميم من خلال موقع صمّم بنفسك .. شاهد التهنئة من هنا 👇👇" },
        { name: "adha", path: "e", message: "أرسلت إليك رسالة تهنئة وتصميم خاص بمناسبة عيد الأضحى\nتم إنشاء التصميم من خلال موقع صمّم بنفسك .. شاهد التهنئة من هنا 👇👇" },
        { name: "hijri", path: "h", message: "أرسلت إليك رسالة تهنئة وتصميم خاص بمناسبة العام الهجري\nتم إنشاء التصميم من خلال موقع صمّم بنفسك .. شاهد التهنئة من هنا 👇👇" },
        { name: "newyear", path: "n", message: "أرسلت إليك رسالة تهنئة وتصميم خاص بمناسبة العام الجديد\nتم إنشاء التصميم من خلال موقع صمّم بنفسك .. شاهد التهنئة من هنا 👇👇" },
        { name: "ramadan", path: "r", message: "أرسلت إليك رسالة تهنئة وتصميم خاص بمناسبة شهر رمضان\nتم إنشاء التصميم من خلال موقع صمّم بنفسك .. شاهد التهنئة من هنا 👇👇" },
    ],
    // user
    // sessionid : utils.getSessionId(),
    sessionid: "",
    cloneDesign: {},
    cacheObject: {},
    dataCloud: null,
    isExceedDesign: false,

    isBadRequest: false,
    ct: "",
    // isUserdisabledcookies : utils.isDisableCookies(),
    // isUserBlockedCookies : utils.isDisableCookies(),
    isUserdisabledcookies: false,
    isUserBlockedCookies: false,
    isUserProxyRequest: false,
    initializeServiceWorker: true, // setup service worker for both web and mob
    isPWA: false,
    subscribe: {
        _subscribeHost: "https://pronileserver11-001-site1.anytempurl.com/api/notifications",
        _subscribeAuth: "Basic MTEyNzQ3Njk6NjAtZGF5ZnJlZXRyaWFs",
        _subscribePublicKey: "BFOoyf3_FA9sumkAHCvycWgerGrjKBiIPkFISXNBnRcrmlpa6fxXURPgPPZRqr7wSJeU6GnOIKa6bTpkaMSvzb8"
    },
    // api config
    dbHost: {
        hosts: [
            {
                _dbHost: "https://trackdb6-002-site1.dtempurl.com",
                _dbAuth: "Basic MTEzMjYyMDU6NjAtZGF5ZnJlZXRyaWFs"
            }
        ],
        // dbApi : `/api/track.php?dt=${utils.getUix()}`,
        dbApi: `/api/track.php?dt=${1111}`,
        reviewApi: "/api/review.php",
        contactApi: "/api/contact.php",
        friendApi: "/api/friends.php",
        shareApi: "/api/share.php",
        ipApi: "/api/ip.php",
        messageApi: "/api/reply.php",
    },

    loadBalancer:
    {

        images: [
            {
                _balancerHost: "https://loadbalancer5-001-site1.ktempurl.com/api/req",
                _balancerAuth: "Basic MTEzMTYyMTk6NjAtZGF5ZnJlZXRyaWFs",
            }
        ],
        videos: [{
            // created by pronilesoft
            _balancerHost: "https://pronileserver2.bsite.net/api/req",
            _balancerAuth: "Basic MTEyODM2Mzc6NjAtZGF5ZnJlZXRyaWFs",
        }]
    }
    ,
    services:
    {
        images:
            [
                ///


                { url: "https://pronileserver169-001-site1.ktempurl.com", auth: "Basic MTEzMjgwNDY6NjAtZGF5ZnJlZXRyaWFs" },
                { url: "https://pronileserver170-001-site1.jtempurl.com", auth: "Basic MTEzMzUwMDc6NjAtZGF5ZnJlZXRyaWFs" },
                { url: "https://pronileserver171-001-site1.ftempurl.com", auth: "Basic MTEzMzY5ODM6NjAtZGF5ZnJlZXRyaWFs" },
                { url: "https://pronileserver172-001-site1.ltempurl.com", auth: "Basic MTEzMzY5ODM6NjAtZGF5ZnJlZXRyaWFs" },
                { url: "https://pronileserver173-001-site1.gtempurl.com", auth: "Basic MTEzMzY5ODM6NjAtZGF5ZnJlZXRyaWFs" }
            ]
        ,
        videos:
            [

                // { url: "https://pronileserver155-001-site1.gtempurl.com", auth: "Basic MTEzMjQ4NzU6NjAtZGF5ZnJlZXRyaWFs" },
                //  { url: "https://pronileserver158-001-site1.ktempurl.com", auth: "Basic MTEzMjY5NTQ6NjAtZGF5ZnJlZXRyaWFs" },
                //  { url: "https://pronileserver154-001-site1.ctempurl.com", auth: "Basic MTEzMjQ4NzU6NjAtZGF5ZnJlZXRyaWFs" },
                //  { url: "https://pronileserver167-001-site1.ftempurl.com", auth: "Basic MTEzMjcxODU6NjAtZGF5ZnJlZXRyaWFs" },
                //  { url: "https://pronileserver168-001-site1.ftempurl.com", auth: "Basic MTEzMjgwNDY6NjAtZGF5ZnJlZXRyaWFs" }

            ]
    },
};

export default config;
